// @ts-nocheck
import "./video.css";
import * as React from "react";

export default function VideoComp(props) {
  return (
    <div className="VideoComp">
      <div className="IdContainer ">
        <div className="id-header">
          <span className="Id">#{props.id}</span>&nbsp;
          <br className="br-portrait" />
          <span>{props.idHeader}</span>
        </div>
      </div>
      <div className="VideoCompContainer">
        <div className="VideoContainer">
          {props.videoBg}
          <video
            playsInline={true}
            autoPlay={true}
            loop={true}
            muted={true}
            data-keepplaying
          >
            <source src={props.vidLink} type="video/mp4" />
          </video>
        </div>
        <div className="ContentContainer ContentContainerRight">
          <div className="MainContent">
            <div className="HeaderContent">{props.header}</div>
            <div className="TextContent">{props.text}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
